import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AuthState, User } from '@fitscovery/auth/data-access';
import { Membership } from '@fitscovery/membership/data-access';
import { Partner } from '@fitscovery/partner/data-access';
import { Select } from '@ngxs/store';
import { environment } from 'apps/partner-web/src/environments/environment';
import { Observable } from 'rxjs';

@Component({
  selector: 'fitscovery-ui-mobile-nav',
  templateUrl: './ui-mobile-nav.component.html',
  styleUrls: ['./ui-mobile-nav.component.scss']
})
export class UiMobileNavComponent implements OnInit, OnDestroy {
  @Input() partner: Partner;
  @Input() memberships?: Membership[];
  @Output() closeNav: EventEmitter<boolean> = new EventEmitter;
  @Output() logoutClicked: EventEmitter<boolean> = new EventEmitter;
  @Output() loginClicked: EventEmitter<boolean> = new EventEmitter;
  isMobileNavOpen: boolean;
  @Select(AuthState.user) userAuthState$: Observable<User>;

  accountUrl: string = environment.fitscoveryApps.accountUrl;
  myDiscoveryUrl: string = environment.fitscoveryApps.myDiscoveryUrl;

  constructor(@Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.isMobileNavOpen = true;
    this.disableBodyScroll();
  }

  ngOnDestroy(): void {
    this.enableBodyScroll();
  }

  public closeMenu(): void {
    if (this.isMobileNavOpen) {
      this.closeNav.emit(true);
    }
  }

  disableBodyScroll(): void {
    const bodyElement = this.document.getElementsByTagName('body')[0];
    bodyElement.style.overflow = 'hidden';
  }

  enableBodyScroll(): void {
    const bodyElement = this.document.getElementsByTagName('body')[0];
    bodyElement.style.overflow = 'auto';
  }

  logout(): void {
    this.logoutClicked.emit(true);
  }

  login(): void {
    this.loginClicked.emit(true);
  }
}
